import { FolderTreeLoadStateEnum } from 'owa-folders';
import { setLoadingStateForFavorites } from './setLoadingStateForFavorites';
import type { AccountKey } from 'owa-client-types';

export const setFavoritesLoaded = (accountKey: AccountKey): void => {
    setLoadingStateForFavorites(accountKey, FolderTreeLoadStateEnum.Loaded);
};
